module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Abbre#fm-1"
    }
  }, [_c('em', [_vm._v("Abbreviations and Symbols")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Foreword#fm-2"
    }
  }, [_c('em', [_vm._v("Editors’ Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Authors#fm-3"
    }
  }, [_c('em', [_vm._v("Author’s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#fm-4"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#ch-1"
    }
  }, [_c('strong', [_vm._v("1 SAMUEL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#ch-1"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Chapter 1")])]), _vm._v(" "), _c('em', [_vm._v("The Overall Shape and Scope of 1–2 Samuel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Chapter 2")])]), _vm._v(" "), _c('em', [_vm._v("The Arrival of Samuel on the National Scene (1 Sam 1–3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Chapter 3")])]), _vm._v(" "), _c('em', [_vm._v("The Departure of the Ark from the National Scene (1 Sam 4–6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Chapter 4")])]), _vm._v(" "), _c('em', [_vm._v("The Emergence of the Monarchy: The Arrival of Saul and the New Institution of Monarchy (1 Sam 7–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Chapter 5")])]), _vm._v(" "), _c('em', [_vm._v("The Emergence of the Monarchy: The Dismissal of Saul and the Beginning of David’s Arrival (1 Sam 13:1–16:13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Chapter 6")])]), _vm._v(" "), _c('em', [_vm._v("David’s Emergence in Israel (1 Sam 16:14–18:16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Chapter 7")])]), _vm._v(" "), _c('em', [_vm._v("Veiled Conflict at the Court (1 Sam 18:17–21:1)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Chapter 8")])]), _vm._v(" "), _c('em', [_vm._v("Open Rupture between David and Saul (1 Sam 21:2–27:12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/018_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Chapter 9")])]), _vm._v(" "), _c('em', [_vm._v("The Ultimate Failure of Saul (1 Sam 28–31)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('em', [_vm._v("Chapter 10")])]), _vm._v(" "), _c('em', [_vm._v("Diachronic Dimension: From Past Texts to Present Text")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Glossary#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Glossary")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb0fd014","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0